import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import ButtonToggle from '../../ButtonToggle/index'
import { getBoundActions } from '../../../actions/index'
import { connect as connectStaticText } from '../../StaticText/connect'
import {
  AUTOPLAY_TOGGLED_GA4_EVENT,
} from '../../../services/event-tracking/index'

const AutoplaySettings = (props) => {
  const { autoPlayNextDisabled, staticText, setFeatureTrackingDataPersistent } = props

  const onAutoPlaySettingsChange = () => {
    setFeatureTrackingDataPersistent({
      data: Map({ disableAutoPlayNext: !autoPlayNextDisabled }),
    })
  }
  const eventDataGA4 = AUTOPLAY_TOGGLED_GA4_EVENT
    .mergeDeep({
      ui_location: 'Settings',
      changed_to: !autoPlayNextDisabled ? 'off' : 'on',
    })

  return (
    <div className="my-account-settings-V2__display-settings-controls">
      <div className="my-account-settings-V2__display-settings-text-container">
        <div className="my-account-settings-V2__display-settings-title">
          { staticText.getIn(['data', 'autoplayNextVideo']) }
        </div>
        <div className="my-account-settings-V2__display-settings-text">
          { staticText.getIn(['data', 'disableAutoplay']) }
        </div>
      </div>
      <div className="my-account-settings-V2__display-settings-toggle">
        <ButtonToggle
          checked={!autoPlayNextDisabled}
          onChange={onAutoPlaySettingsChange}
          showLabel
          ga4EventData={eventDataGA4}
          round
        />
      </div>
    </div>
  )
}

AutoplaySettings.propTypes = {
  autoPlayNextDisabled: PropTypes.bool,
  setFeatureTrackingDataPersistent: PropTypes.func.isRequired,
}

export default compose(
  connectRedux(
    (state) => {
      return {
        autoPlayNextDisabled: state.featureTracking.getIn(['data', 'disableAutoPlayNext'], false),
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setFeatureTrackingDataPersistent: actions.featureTracking.setFeatureTrackingDataPersistent,
      }
    },
  ),
  connectStaticText({ storeKey: 'myAccountSettingsV2' }),
)(AutoplaySettings)
